/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import NavItem from '../NavItem';
import LoopNavCollapse from './index';
import NavIcon from '../NavIcon';
import NavBadge from '../NavBadge';

import { configActions } from './../../../../../features/Config/ConfigSlice';
import * as actionType from '../../../../../features/Config/Types';

const NavCollapse = ({ collapse, type }) => {
  const { layout, isOpen, isTrigger, collapseMenu } = useSelector((state) => state.config);
  const { can_approve_po } = useSelector((state) => state.auth);
  const { currentVendor } = useSelector((state) => state.vendor);

  const dispatch = useDispatch();

  useEffect(() => {
    const currentIndex = document.location.pathname
      .toString()
      .split('/')
      .findIndex((id) => id === collapse.id);
    if (currentIndex > -1) {
      dispatch(
        configActions.update({ type: actionType.COLLAPSE_TOGGLE, menu: { id: collapse.id, type } })
      );
    }
  }, [collapse, type]);

  useEffect(() => {
    if (collapseMenu === true) {
      dispatch(configActions.update({ type: actionType.RESET_COLLAPSE_MENU }));
    }
  }, [collapseMenu]);

  let navItems = '';
  if (collapse.children) {
    const collapses = collapse.children;
    navItems = Object.keys(collapses).map((item) => {
      item = collapses[item];
      switch (item.type) {
        case 'collapse':
          return <LoopNavCollapse key={item.id} collapse={item} type="sub" />;
        case 'item':
          if (item.allowedVendors === '*') {
            if (item.id === 'feedback_orders') {
              if (can_approve_po === true) {
                return <NavItem layout={layout} key={item.id} item={item} />;
              } else {
                return false;
              }
            } else {
              return <NavItem layout={layout} key={item.id} item={item} />;
            }
          } else {
            if (currentVendor.VendorType === item.allowedVendors) {
              if (item.id === 'feedback_orders') {
                if (can_approve_po === true) {
                  return <NavItem layout={layout} key={item.id} item={item} />;
                } else {
                  return false;
                }
              } else {
                return <NavItem layout={layout} key={item.id} item={item} />;
              }
            } else {
              return false;
            }
          }
        default:
          return false;
      }
    });
  }

  let itemTitle = collapse.title;
  if (collapse.icon) {
    itemTitle = <span className="pcoded-mtext">{collapse.title}</span>;
  }

  let navLinkClass = ['nav-link'];

  let navItemClass = ['nav-item', 'pcoded-hasmenu'];
  const openIndex = isOpen.findIndex((id) => id === collapse.id);
  if (openIndex > -1) {
    navItemClass = [...navItemClass, 'active'];
    if (layout !== 'horizontal') {
      navLinkClass = [...navLinkClass, 'active'];
    }
  }

  const triggerIndex = isTrigger.findIndex((id) => id === collapse.id);
  if (triggerIndex > -1) {
    navItemClass = [...navItemClass, 'pcoded-trigger'];
  }

  const currentIndex = document.location.pathname
    .toString()
    .split('/')
    .findIndex((id) => id === collapse.id);
  if (currentIndex > -1) {
    navItemClass = [...navItemClass, 'active'];
    if (layout !== 'horizontal') {
      navLinkClass = [...navLinkClass, 'active'];
    }
  }

  const subContent = (
    <React.Fragment>
      <Link
        to="#"
        className={navLinkClass.join(' ')}
        onClick={() =>
          dispatch(
            configActions.update({
              type: actionType.COLLAPSE_TOGGLE,
              menu: { id: collapse.id, type }
            })
          )
        }
      >
        <NavIcon items={collapse} />
        {itemTitle}
        <NavBadge items={collapse} />
      </Link>
      <ListGroup variant="flush" bsPrefix=" " as="ul" className="pcoded-submenu">
        {navItems}
      </ListGroup>
    </React.Fragment>
  );

  let mainContent = '';
  if (layout === 'horizontal') {
    mainContent = (
      <ListGroup.Item
        as="li"
        bsPrefix=" "
        className={navItemClass.join(' ')}
        onMouseLeave={() =>
          dispatch(
            configActions.update({
              type: actionType.NAV_COLLAPSE_LEAVE,
              menu: { id: collapse.id, type }
            })
          )
        }
        onMouseEnter={() =>
          dispatch(
            configActions.update({
              type: actionType.COLLAPSE_TOGGLE,
              menu: { id: collapse.id, type }
            })
          )
        }
      >
        {subContent}
      </ListGroup.Item>
    );
  } else {
    mainContent = (
      <ListGroup.Item as="li" bsPrefix=" " className={navItemClass.join(' ')}>
        {subContent}
      </ListGroup.Item>
    );
  }
  return <React.Fragment>{mainContent}</React.Fragment>;
};

export default NavCollapse;
